export class DateParameterRequestTO{
	public nombreParametro!: string;
	public valorParametro!: string;
	public descripcionParametro!: string;
}